<div class="d--f jc--sb ai--c mt-2">
  <div class="f-700 fs-20">Specialities</div>
  <div class="d--f ai--c">
    <button
      mat-raised-button
      color="primary"
      (click)="openSpecialityForm($event)"
    >
      <span> Add </span>
    </button>
  </div>
</div>

<div *ngIf="isLoading" class="d--f jc--c mt-3">
  <mat-spinner color="primary" diameter="50"></mat-spinner>
</div>

<div
  class="table-view-container mt-2"
  [hidden]="!(!isLoading && dataSource.data.length > 0)"
>
  <table mat-table [dataSource]="dataSource" [trackBy]="trackByFn">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Speciality</th>
      <td mat-cell *matCellDef="let speciality">
        <div class="f-400">{{ speciality.name | titlecase }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let speciality">
        <div class="d--f ai--c jc--fe">
          <mat-icon
            color="primary"
            class="pointer"
            (click)="openSpecialityForm($event, speciality)"
          >
            edit
          </mat-icon>
          <mat-icon
            color="primary"
            class="pointer"
            (click)="openDeleteConfirmation($event, speciality)"
          >
            delete
          </mat-icon>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="specialityTableCols"></tr>
    <tr mat-row *matRowDef="let row; columns: specialityTableCols"></tr>
  </table>
</div>

<my-rep-empty-screen
  [options]="emptyScreenOptions"
  *ngIf="!isLoading && dataSource.data.length === 0"
></my-rep-empty-screen>
